import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@iconify/react';

function Footer() {
    const [email, setEmail] = useState('');
    const [subscribed, setSubscribed] = useState(false);

    const handleNewsletterSubmit = (e) => {
        e.preventDefault();
        if (email) {
            // Handle newsletter subscription
            console.log('Newsletter subscription:', email);
            setSubscribed(true);
            setEmail('');
            setTimeout(() => setSubscribed(false), 3000);
        }
    };

    const handleDonateClick = () => {
        console.log('Footer donate clicked');
    };

    return (
        <footer className="footer">

            <div className="container">
                <div className="row g-4">
                    <div className="col-lg-4 col-md-6">
                        <div className="footer-section">
                            <div className="footer-brand">
                                <Icon icon="medical-icon:health-services" className="footer-brand-icon" />
                                <h3>HSCF</h3>
                            </div>
                            <p className="footer-description">
                                HSCF is an indigenous nonprofit organization dedicated to advancing the health and well-being of underserved communities, with a special focus on those living in remote and marginalized areas.
                            </p>
                            {/*
                            <div className="social-links">
                                <a href="#" className="social-link" aria-label="Facebook">
                                <Icon icon="mdi:facebook" />
                                </a>
                                <a href="#" className="social-link" aria-label="Twitter">
                                <Icon icon="mdi:twitter" />
                                </a>
                                <a href="#" className="social-link" aria-label="LinkedIn">
                                <Icon icon="mdi:linkedin" />
                                </a>
                                <a href="#" className="social-link" aria-label="Instagram">
                                <Icon icon="mdi:instagram" />
                                </a>
                            </div>
                            */}
                        </div>
                    </div>

                    <div className="col-lg-2 col-md-6">
                        <div className="footer-section">
                            <h4 className="footer-title">Quick Links</h4>
                            <ul className="footer-links">
                                <li><Link to="/">Home</Link></li>
                                <li><Link to="/about">About</Link></li>
                                <li><Link to="/programs">Programs</Link></li>
                                {/*
                                <li><Link to="/resources">Resources</Link></li>
                                */}
                                <li><Link to="/contact">Contact</Link></li>
                            </ul>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6">
                        <div className="footer-section">
                            <h4 className="footer-title">Our Programs</h4>
                            <ul className="footer-links">
                                <li><Link to="/programs/educateher">EducateHer</Link></li>
                                <li><Link to="/programs/rtygia">RTYGIA</Link></li>
                                <li><Link to="/programs/aikpokpodion-fellowship">Aikpokpodion Fellowship</Link></li>
                            </ul>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6">
                        <div className="footer-section">
                            <h4 className="footer-title">Newsletter</h4>
                            <p className="newsletter-text">Stay updated with our latest initiatives and opportunities.</p>
                            <form className="newsletter-form" onSubmit={handleNewsletterSubmit}>
                                <div className="input-group">
                                    <input
                                        type="email"
                                        className="form-control"
                                        placeholder="Your email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                    <button className="btn btn-newsletter" type="submit">
                                        <Icon icon="material-symbols:send" />
                                    </button>
                                </div>
                                {subscribed && (
                                    <div className="subscription-success">
                                        <Icon icon="mdi:check-circle" className="me-2" />
                                        Successfully subscribed!
                                    </div>
                                )}
                            </form>
                            {/*
                            <button className="btn btn-donate-footer mt-3" onClick={handleDonateClick}>
                                <Icon icon="mdi:hand-heart" className="me-2" />
                                Support Our Mission
                            </button>
                            */}
                        </div>
                    </div>
                </div>

                <hr className="footer-divider" />

                <div className="row">
                    <div className="col-md-6 text-center text-md-start">
                        <p className="footer-copyright">
                            © {new Date().getFullYear()} HSCF. All rights reserved.
                        </p>
                    </div>
                    {/*
                    <div className="col-md-6 text-center text-md-end">
                        <div className="footer-legal">
                        <a href="#">Privacy Policy</a>
                        <span className="separator">|</span>
                        <a href="#">Terms of Service</a>
                        </div>
                    </div>
                    */}
                </div>
            </div>
        </footer>
    );
}

export default Footer;
